import { useState, useEffect } from 'react'
import { AdminSettingsService } from '../services/adminSettings'
import {
  AI_RESPONSE_POLICY_OPTIONS,
  AI_RESPONSE_POLICY_SETTING_KEYS,
  type AiResponsePolicyOption,
} from '../constants/aiResponsePolicy'

const defaultOptions = (): AiResponsePolicyOption[] =>
  AI_RESPONSE_POLICY_OPTIONS.map((option) => ({ value: option.value, label: option.label }))

/**
 * AI回答方針 radio options with the admin-edited titles applied.
 *
 * Titles live in admin_settings (is_public = true so teachers can read them under RLS).
 * Any row that is missing, blank, or unreadable falls back to the built-in label, so the
 * school settings screen always renders even if the settings can't be loaded.
 */
export const useAiResponsePolicyOptions = () => {
  const [options, setOptions] = useState<AiResponsePolicyOption[]>(defaultOptions)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      const result = await AdminSettingsService.getPublicSettings()

      if (cancelled) return

      if (result.success) {
        const labels = new Map(
          result.data.map((setting) => [setting.key, setting.value])
        )
        setOptions(
          AI_RESPONSE_POLICY_OPTIONS.map((option) => {
            const stored = labels.get(AI_RESPONSE_POLICY_SETTING_KEYS[option.value].label)
            const label = typeof stored === 'string' && stored.trim() ? stored.trim() : option.label
            return { value: option.value, label }
          })
        )
      }

      setIsLoading(false)
    }

    load()

    return () => {
      cancelled = true
    }
  }, [])

  return { options, isLoading }
}
